module.exports = __webpack_public_path__ + "static/img/朱总333人才证书.3259010b.png";